module.exports = __webpack_public_path__ + "media/landing-desktop/assets/images/sr-brand-logo-black-8903dcb01f040ed0c3fa841db91f4b4c.svg";